import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TKhattabatConversations } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetConversations = async ({
  alKhattabaUUID,
  userUUID,
  oneOOneCId
}: {
  alKhattabaUUID: string;
  userUUID: string;
  oneOOneCId: string;
}): Promise<{
  data: TKhattabatConversations;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TKhattabatConversations>(
    `khattabat/getAlkhattabatConverstions`,
    {
      alKhattabaUUID,
      userUUID,
      oneOOneCId
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        oneOOneCMessages: [],
        oneOOneCComments: [],
        oneOTwoMessages: {},
        alKhattabaUUID: "",
        userUUID: "",
        userID: -1,
        oneOOneCId: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        oneOOneCMessages: [],
        oneOOneCComments: [],
        oneOTwoMessages: {},
        alKhattabaUUID: "",
        userUUID: "",
        userID: -1,
        oneOOneCId: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
